module.exports = __webpack_public_path__ + "static/media/apple.d43299e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/apple.png
// module id = 90
// module chunks = 0